"use strict";

exports.__esModule = true;
exports.CALENDAR_EDIT_THRESHOLD = void 0;
exports.CalendarEventEditor = CalendarEventEditor;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
var _timeDefinitions = require("../../timeDefinitions");
var _CalendarEventConfigDetails = require("../CalendarEventConfigDetails");
var _SingletonCalendarEventForm = require("../SingletonCalendarEvent/SingletonCalendarEventForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CALENDAR_EDIT_THRESHOLD = exports.CALENDAR_EDIT_THRESHOLD = _timeDefinitions.DAY_IN_MILLIS;
var canEditItem = function canEditItem(_ref) {
  var interval = _ref.interval;
  var now = Date.now();
  return interval.startMillis > now + CALENDAR_EDIT_THRESHOLD;
};
var EditorContainer = _styledComponents["default"].div.withConfig({
  displayName: "CalendarEventEditor__EditorContainer",
  componentId: "sc-lvs6xj-0"
})(["display:flex;flex-direction:column;"]);
var BottomCallout = (0, _styledComponents["default"])(_core.Callout).withConfig({
  displayName: "CalendarEventEditor__BottomCallout",
  componentId: "sc-lvs6xj-1"
})(["margin-top:auto;margin-bottom:1rem;"]);
function CalendarEventEditor(_ref2) {
  var schedule = _ref2.schedule,
    event = _ref2.event,
    config = _ref2.config,
    _onSubmit = _ref2.onSubmit,
    _onDelete = _ref2.onDelete,
    onCancel = _ref2.onCancel;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  if (schedule) {
    var scheduleID = schedule.id;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "CalendarEventEditor"
    }, config && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, config.payload.name), /*#__PURE__*/_react["default"].createElement(_CalendarEventConfigDetails.CalendarEventConfigDetails, {
      config: config
    }), /*#__PURE__*/_react["default"].createElement("hr", null)), !canEditItem(schedule) ? /*#__PURE__*/_react["default"].createElement(_core.Callout, {
      "data-testid": "CalendarEventEditor.CannotEdit",
      icon: "calendar",
      title: translate("CalendarEventEditor.callout.title", "This schedule is already active")
    }, translate("CalendarEventEditor.callout.description", "Active schedule can't be edited. Create a new Schedule to change events for a device, set of devices or the entire plant."), " ", /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/create-schedule",
      text: translate("CalendarEventEditor.callout.createScheduleButton", "Create a new Schedule")
    })) : scheduleID && /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "CalendarEventEditor.CanEdit"
    }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/schedules/" + scheduleID,
      text: translate("CalendarEventEditor.editScheduleButton", "Edit this Schedule")
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(EditorContainer, {
    "data-testid": "CalendarEventEditor"
  }, /*#__PURE__*/_react["default"].createElement(_SingletonCalendarEventForm.SingletonCalendarEventForm, {
    event: event,
    onSubmit: function onSubmit(input) {
      return _onSubmit(Object.assign({}, input, {
        id: event.id
      }));
    },
    onDelete: function onDelete() {
      return event.id && _onDelete(event.id);
    },
    onCancel: onCancel
  }), /*#__PURE__*/_react["default"].createElement(BottomCallout, {
    icon: "calendar",
    title: translate("CalendarEventEditor.bottomCallout.title", "Need repeating events?")
  }, /*#__PURE__*/_react["default"].createElement("p", null, translate("CalendarEventEditor.bottomCallout.description", "Create a new schedule to configure repeating shifts and classifications for specific devices or the entire plant.")), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    icon: _icons.IconNames.ADD,
    to: "/calendar/create-schedule",
    text: translate("CalendarEventEditor.bottomCallout.createScheduleButton", "Create a new Schedule")
  })));
}